const REGEX_STORYBLOK_PNG = /https?:\/\/(a.storyblok.com).*(.png)(?:.*)/

export const isStoryblokPNGImage = (src: string) => {
  const result = REGEX_STORYBLOK_PNG.exec(src)
  return Boolean(result)
}
